export const REQUIRED_COOKIES_MAP = {
  MVID_CITY_ID: 'CityCZ_975',
  MVID_REGION_ID: '1',
  MVID_REGION_SHOP: 'S002',
  MVID_TIMEZONE_OFFSET: '3',
};
